import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-daily-reports',
  templateUrl: './daily-reports.component.html',
  styleUrls: ['./daily-reports.component.css']
})
export class DailyReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
